export const serverDateFormat = 'YYYY-MM-DD';
